const loginPortalUrl = import.meta.env.VITE_LOGIN_URL || 'https://login.timelog.com';

export default loginPortalUrl;
